import { useState } from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import RevenueSection from '@/components/payroll_tsx/AnalyticsBoard/components/RevenueSection';
import ServiceEmployeeSection from '@/components/payroll_tsx/AnalyticsBoard/components/ServiceEmployeeSection';

export default function AnalyticsBoard() {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
  const months = Array.from({ length: 12 }, (_, i) => ({
    value: i,
    label: new Date(2000, i).toLocaleString('default', { month: 'long' }),
  }));

  const handleDateChange = (year: number, month: number) => {
    setSelectedYear(year);
    setSelectedMonth(month);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between space-y-2">
        <div className="flex items-center space-x-2 ">
          <Select
            value={selectedYear.toString()}
            onValueChange={value => setSelectedYear(parseInt(value))}
          >
            <SelectTrigger className="w-[188px]">
              <SelectValue placeholder="Select year" />
            </SelectTrigger>
            <SelectContent>
              {years.map(year => (
                <SelectItem key={year} value={year.toString()}>
                  {year}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Select
            value={selectedMonth.toString()}
            onValueChange={value => setSelectedMonth(parseInt(value))}
          >
            <SelectTrigger className="w-[188px]">
              <SelectValue placeholder="Select month" />
            </SelectTrigger>
            <SelectContent>
              {months.map((month, index) => (
                <SelectItem key={index} value={index.toString()}>
                  {month.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid gap-1 sm:gap-3">
        <RevenueSection selectedYear={selectedYear} selectedMonth={selectedMonth} />
        <ServiceEmployeeSection
          selectedYear={selectedYear}
          selectedMonth={selectedMonth}
          onYearChange={year => handleDateChange(year, selectedMonth)}
          onMonthChange={month => handleDateChange(selectedYear, month)}
        />
      </div>
    </div>
  );
}
